import {Inject, Injectable} from '@angular/core';
import {GeneralService} from "../general.service";
import {HttpClient} from "@angular/common/http";
import {map, shareReplay} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class SysDataModelFieldService extends GeneralService {
  cacheMap: any;
  constructor(
      public http: HttpClient,
      @Inject('httpBaseSettings') public httpBaseSettings: any
  ) {
    super(http, httpBaseSettings);
    this.setModelPath('/base/sysDataModelField');
    this.cacheMap = {};
  }

  getById(id) {
    if (!this.cacheMap[id]) {
      this.cacheMap[id] = super.searchData({dataModelId: id}).pipe(
        shareReplay(1)
      );
      setTimeout(() => {
        this.cacheMap[id] = null;
      }, 10000);
      return this.cacheMap[id];
    } else {
      return this.cacheMap[id];
    }
  }

  save(obj) {
    this.cacheMap = {};
    return super.save(obj);
  }

  remove(obj) {
    this.cacheMap = {};
    return super.remove(obj);
  }

  getByIds(ids) {
    return this.http.post(this.httpBase + '/base/sysDataModelField/selectListByIdList', ids)
  }
}
